import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

import { QRCodeComponent } from 'angularx-qrcode';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserData, LinkData } from '../../Models/Authentication/UserModel';
import { User } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ImageUploadService } from '../../Services/image-upload.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.css'],standalone:false
})
export class QrCodeComponent extends BaseComponent implements OnInit {
  @ViewChild('qrcode', { static: true }) qrcode!: QRCodeComponent;
  user!:User
  user1!:UserData
  userId:string;
  form!: FormGroup;
  Links!: FormGroup;
  imageUrl: string = '../../../assets/images/Linktree/templates/DumyUser.png';
  loading:boolean=false;
  userRole:string='';
  linksData:LinkData[]=[]
  socialLink:LinkData[]=[]
  showUpdate:boolean=false
  mess:string=''
  socialMediaPlatforms = [
    { name: 'Facebook', icon: 'fab fa-facebook-square' },
    { name: 'Instagram', icon: 'fab fa-instagram' },
    { name: 'Twitter', icon: 'fab fa-twitter' },
    { name: 'LinkedIn', icon: 'fab fa-linkedin' },
    { name: 'YouTube', icon: 'fab fa-youtube' },
    { name: 'Snapchat', icon: 'fab fa-snapchat' },
    { name: 'WhatsApp', icon: 'fab fa-whatsapp' },
    { name: 'TikTok', icon: 'fab fa-tiktok' },
    { name: 'Pinterest', icon: 'fab fa-pinterest' },
    { name: 'Reddit', icon: 'fab fa-reddit' },
    { name: 'Tumblr', icon: 'fab fa-tumblr' },
    { name: 'WeChat', icon: 'fab fa-weixin' },
    { name: 'Thread', icon: 'fas fa-comment-alt' },
    { name: 'Apple App Store', icon: 'fab fa-app-store-ios' },
    { name: 'Apple Music', icon: 'fab fa-itunes-note' },
    { name: 'Amazon', icon: 'fab fa-amazon' },
    { name: 'Google', icon: 'fab fa-google' },
    { name: 'Google Meet', icon: 'fab fa-google-plus-g' },
    { name: 'Apple Podcast', icon: 'fab fa-itunes' },
    { name: 'App', icon: 'fas fa-mobile-alt' },
    { name: 'BeReal', icon: 'fas fa-smile' },
    { name: 'Bandcamp', icon: 'fab fa-bandcamp' },
    { name: 'Bluesky', icon: 'fas fa-cloud' },
    { name: 'Cameo', icon: 'fas fa-camera' },
    { name: 'Clubhouse', icon: 'fas fa-house-user' },
    { name: 'Etsy', icon: 'fab fa-etsy' },
    { name: 'LinkedIn', icon: 'fab fa-linkedin' },
    { name: 'GitHub', icon: 'fab fa-github' },
    { name: 'Patreon', icon: 'fab fa-patreon' },
    { name: 'Mastodon', icon: 'fab fa-mastodon' },
    { name: 'Kick', icon: 'fas fa-boot' },
    { name: 'Poshmark', icon: 'fa-regular fa-hourglass' },
    { name: 'SoundCloud', icon: 'fab fa-soundcloud' },
    { name: 'Spotify', icon: 'fab fa-spotify' },
    { name: 'Substack', icon: 'fas fa-newspaper' },
    { name: 'Telegram', icon: 'fab fa-telegram' },
    { name: 'Signal', icon: 'fa-regular fa-comment' },
    { name: 'Twitch', icon: 'fab fa-twitch' }
  ];
  userName: string = "John Doe";
  userImage: string = "path_to_user_image.jpg";
  username:string="https://touchconnectapp.web.app/"
  constructor
    (
      private http:HttpClient,
      private renderer: Renderer2,
      private el: ElementRef,
      private auth: AuthService,
      private messageService: MessageService,
      private fb: FormBuilder,
      private api: BaseApiService,
      private imageUploadService: ImageUploadService

    ) {
    super()
    this.userId   = this.auth.getUID();
    this.userRole = this.auth.getRoles().toString();

  }

  getdata(uid:any){
    this.loading=true;
    this.api.read(`Auth/getProfile?uid=${uid}`).pipe
    (
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next:(response)=>{
          this.user = response;
          if(this.user!=null){
            this.form.patchValue(this.user)
            this.loading=false;
          }
          this.loading=false;
        }
        ,
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }

    )
  }

  singleLink(link:LinkData)
  {
     this.showUpdate=true;
     this.Links.patchValue(link);
  }


  GetAll(uid:any){
   this.loading=true;
   this.api.read(`Auth/getByIdDT?uid=${uid}`)
   .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
   )
   .subscribe
   (
     {
        next:(response)=>{
          this.user1 = response;
          this.username = this.username+this.user1.userName
          this.loading=false;
        },
        error:(
          error
        )=>{
   
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
     }

   )
  }

  selectPlatform(platform: any)
  {
    this.Links.get('linkType')?.setValue(platform);
    this.mess=platform;
  }
  GetAllLinks(uid:any){
    this.loading=true;
    this.api.read(`SocialLinks/UserLinks?userid=${uid}`).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next:(response)=>{
          this.linksData = response;
          this.loading   = false;
        }
        ,
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
   }


   GetSocilaLinks(uid:any){
    this.loading=true;
    this.api.read(`SocialLinks/SocilaLinks?userid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
       {
          next: (response)=>{
            this.socialLink = response;
            this.loading    =false;
          },
          error:(
            error
          )=>{
    
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
       }
    )
   }


  initilizeForm(){
    this.loading=true;
    this.form = this.fb.group({
      id: [''],
      title: [''],
      description: [''],
      image:  [this.imageUrl],
      userid: [this.userId],
    });
    this.loading=false;
  }

  initilizeFormLink(){
    this.loading =true;
    this.Links   = this.fb.group
    ({
      id: [''],
      userId: [this.userId],
      linkType: [''],
      link: ['',Validators.required],
      linkIcon:  ['Social'],
    });
    this.loading=false;
  }
  ngOnInit(): void {
    this.initilizeFormLink();
    this.initilizeForm()
    this.GetSocilaLinks(this.userId);
    this.GetAllLinks(this.userId);
    this.GetAll(this.userId);
    this.getdata(this.userId);

  }

  onSubmit(): void {
    this.loading = true;
    this.api.update("Auth/UpdateProfile", this.form.value)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
      (
        {
          next:(response) => {
            this.getdata(this.userId);
            this.GetAll(this.userId);
            this.GetAllLinks(this.userId);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
            this.loading = false;
          },
          error:(
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      )
  }

  onSubmitLinks(): void {
    this.loading     = true;
    const dataToSend = { ...this.Links.value };
    delete dataToSend.id;
    this.api.create("SocialLinks", dataToSend)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      }
      )
    )
    .subscribe
      (
        {
          next:(response) =>
            {
              this.getdata(this.userId);
              this.GetAll(this.userId);
              this.GetSocilaLinks(this.userId);
              this.GetAllLinks(this.userId);
              this.Links.reset()
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Your link added Successfully" });
              this.loading = false;
            },
          error: (
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
        
      )
  }

  onDelete(id:any): void {
    this.loading = true;
    this.api.delete(`SocialLinks?id=${id}`).pipe
    (
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      }
      )

    ).subscribe
      (

         {
             next:(response) =>
              {
                this.getdata(this.userId);
                this.GetAll(this.userId);
                this.GetSocilaLinks(this.userId);
                this.GetAllLinks(this.userId);
                this.messageService.add({ severity: 'success', summary: 'Success', detail: "Your link deleted Successfully" });
                this.loading = false;
              },
            error:(
              error
            ) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            }
         }
      )
  }
  onUpdate(): void {
    this.loading = true;
    const dataToSend = { ...this.Links.value };
    this.api.update("SocialLinks", dataToSend)
    .pipe
    (
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      }
      )
    )
    .subscribe
      ( 
        {
          next:(response) =>
            {
              this.getdata(this.userId);
              this.GetAll(this.userId);
              this.GetSocilaLinks(this.userId);
              this.GetAllLinks(this.userId);
              this.showUpdate=false;
              this.Links.reset()
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Your link Update Successfully" });
              this.loading = false;
            },
          error:(
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }

      )
  }




  upload(event: any): void {
    this.loading = true
    const file: File = event.target.files[0];
    if (file) {

      this.imageUploadService.uploadImage(file)
        .subscribe
        ((imageUrl: string) => {
          this.imageUrl = imageUrl;
          this.form.get('image')?.setValue(imageUrl);
          this.loading = false;
        }
          , (error) => {
            {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error });

            }
          }
        );
    }
  }

  GetPkPass(userId:string)
   {
    this.loading = true;
    const url = `Auth/MembershipCard?userId=${userId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.apple.pkpass'
    });

    this.http.get(url, {
      headers: headers,
      responseType: 'blob' // Set response type to blob for file download
    }).subscribe(
      (response: Blob) => {
        // Create a blob URL for the file
        const blob = new Blob([response], { type: 'application/vnd.apple.pkpass' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and click it to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.download = userId.substring(0,3)+".pkpass";
        document.body.appendChild(link);
        link.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    );

  }
  downloadQRCode() {
    // Find the QR code element by class name
    const qrcodeElement = this.el.nativeElement.querySelector('.qrcode');

    if (qrcodeElement) {
      // Get the canvas element within the QR code component
      const canvas = qrcodeElement.querySelector('canvas');

      if (canvas) {
        // Convert the canvas content to a data URL
        const url = canvas.toDataURL();

        // Create an anchor element
        const a = this.renderer.createElement('a');
        // Set its href to the data URL of the QR code
        a.href = url;
        // Set the download attribute to specify the file name
        a.download = 'qrcode.png';

        // Append the anchor element to the body and trigger a click event
        this.renderer.appendChild(document.body, a);
        a.click();
        // Remove the anchor element from the DOM
        this.renderer.removeChild(document.body, a);
      } else {
      }
    } else {
    }

   }

  downloadPass() {
     // Find the QR code element by class name
  const qrcodeElement = this.el.nativeElement.querySelector('.qrcode');

  if (qrcodeElement) {
    // Get the canvas element within the QR code component
    const canvas = qrcodeElement.querySelector('canvas');

    if (canvas) {
      // Get the data URL of the QR code image
      const qrCodeDataURL = canvas.toDataURL();

      // Create a new instance of JSZip
      const zip = new JSZip();

      // Add the pass.json file
      const passJson = {
        "formatVersion": 1,
        "passTypeIdentifier": "pass.com.example.passbook",
        "serialNumber": "123456",
        "teamIdentifier": this.userId,
        "organizationName": "Touch Connect",
        "description": "My Profile",
        "backgroundColor": "rgb(255,255,255)",
        "labelColor": "rgb(0,0,0)",
        "foregroundColor": "rgb(0,0,0)",
        "barcode": {
          "message": this.userId,
          "format": "PKBarcodeFormatQR",
          "messageEncoding": "iso-8859-1"
        },
        "boardingPass": {
          "headerFields": [
            {
              "key": "flight",
              "label": "Flight",
              "value": "XY123"
            }
          ],
          "primaryFields": [
            {
              "key": "name",
              "label": "Name",
              "value": "John Doe"
            }
          ],
          "secondaryFields": [
            {
              "key": "gate",
              "label": "Gate",
              "value": "B12"
            }
          ],
          "auxiliaryFields": [
            {
              "key": "seat",
              "label": "Seat",
              "value": "12A"
            }
          ],
          "backFields": [
            {
              "key": "info",
              "label": "Additional Info",
              "value": "Boarding starts at 9:00 AM"
            }
          ]
        }
      };
      zip.file('pass.json', JSON.stringify(passJson));

      // Convert the QR code data URL to a blob
      fetch(qrCodeDataURL)
        .then(res => res.blob())
        .then(blob => {
          // Add the QR code image to the zip
          zip.file('qr_code.png', blob);

          // Generate the .pkpass file
          zip.generateAsync({ type: 'blob' })
            .then(content => {
              // Save the .pkpass file
              saveAs(content, 'passbook.pkpass');
            });
        });
    } else {
    }
  } else {
  }
}


}
